"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class CallListModel {
    constructor(json) {
        json = json || {};
        Object.keys(json).forEach((key) => {
            this[key] = json[key];
        });
        this.sortMembers();
    }
    static transformToDB(callList) {
        return CallListModel.DB_FIELDS.reduce((dbCallList, field) => {
            dbCallList[field] = callList[field];
            return dbCallList;
        }, {});
    }
    get completedToday() {
        if (!this.members) {
            return null;
        }
        let completed = 0;
        this.members.forEach((member) => {
            if (new Date(member.lastActivityDate).toDateString() ===
                new Date().toDateString()) {
                completed++;
            }
        });
        return completed;
    }
    get isLessThanMemberLimit() {
        return this.members.length < CallListModel.CALL_LIST_MEMBER_LIMIT;
    }
    get isContactGroupList() {
        return (this.configJson && this.configJson.type === CallListModel.TYPE.CONTACT_GROUP_LIST) ||
            this.type === CallListModel.TYPE.CONTACT_GROUP_LIST;
    }
    get isTaskList() {
        return (this.configJson && this.configJson.type === CallListModel.TYPE.TASK_LIST) ||
            this.type === CallListModel.TYPE.TASK_LIST;
    }
    get isCoreClientsList() {
        return (this.configJson && this.configJson.type === CallListModel.TYPE.CORE_CLIENTS) ||
            this.type === CallListModel.TYPE.CORE_CLIENTS;
    }
    get isDealList() {
        return this.type === CallListModel.TYPE.DEAL_LIST;
    }
    get isAptoGenerated() {
        return this.isTaskList || this.isCoreClientsList;
    }
    get isLegacy() {
        return !this.type && !!this.configJson.type;
    }
    get isPending() {
        return Boolean(this.batchInfo);
    }
    get statusToMembers() {
        return {
            [CallListModel.MARKETING_STATUSES.PROSPECTS]: this.prospects,
            [CallListModel.MARKETING_STATUSES.CONTACTED]: this.contacted,
            [CallListModel.MARKETING_STATUSES.MATERIALS_SENT]: this.materialsSent,
            [CallListModel.MARKETING_STATUSES.TOURED]: this.toured,
            [CallListModel.MARKETING_STATUSES.OFFERED]: this.offered,
            [CallListModel.MARKETING_STATUSES.ALL]: this.members,
            undefined: this.members
        };
    }
    contactsNotCalled(marketingStatus) {
        if (!this.members) {
            return 0;
        }
        const members = this.statusToMembers[marketingStatus] || [];
        return members.filter(member => !member.callResult).length;
    }
    hoursToCall(marketingStatus) {
        const minutesInHours = 60;
        return this.contactsNotCalled(marketingStatus) * CallListModel.MINUTES_PER_CALL / minutesInHours;
    }
    sortMembers() {
        if (this.members) {
            const sortByName = (a, b) => {
                const aName = a.contact && a.contact.fullName && a.contact.fullName.toLowerCase() || '';
                const bName = b.contact && b.contact.fullName && b.contact.fullName.toLowerCase() || '';
                if (aName < bName) {
                    return -1;
                }
                else if (aName > bName) {
                    return 1;
                }
                return 0;
            };
            this.members.sort((a, b) => {
                // ascending sort with empty dates at beginning
                // secondary sort on contact name
                if (!a.lastActivityDate && !b.lastActivityDate) {
                    return sortByName(a, b);
                }
                else if (!a.lastActivityDate) {
                    return -1;
                }
                else if (!b.lastActivityDate) {
                    return 1;
                }
                else if (a.lastActivityDate < b.lastActivityDate) {
                    return -1;
                }
                else if (a.lastActivityDate > b.lastActivityDate) {
                    return 1;
                }
                return sortByName(a, b);
            });
        }
    }
    nextContact(currentId, marketingStatus) {
        const members = this.statusToMembers[marketingStatus];
        if (members) {
            let index = members.findIndex(member => member.contactId === currentId);
            const max = members.length - 1;
            while (index < max) {
                const nextMember = members[++index];
                if (!nextMember.callResult) {
                    return nextMember;
                }
            }
        }
        return undefined;
    }
    previousContact(currentId, marketingStatus) {
        const members = this.statusToMembers[marketingStatus];
        if (members) {
            let index = members.findIndex(member => member.contactId === currentId);
            while (index > 0) {
                const previousMember = members[--index];
                if (!previousMember.callResult) {
                    return previousMember;
                }
            }
        }
        return undefined;
    }
}
CallListModel.TYPE = {
    CONTACT_GROUP_LIST: 'ContactGroupList',
    TASK_LIST: 'TaskList',
    CORE_CLIENTS: 'CoreClients',
    DEAL_LIST: 'DealList'
};
CallListModel.MARKETING_STATUSES = Object.assign({ PROSPECTS: 'Prospects' }, _1.TaskModel.MARKETING_STATUSES, { ALL: 'START CALLING ALL' });
CallListModel.CALL_LIST_MEMBER_LIMIT = 1000;
CallListModel.DB_FIELDS = ['sfUserId', 'name', 'description', 'configJson', '_id', 'contactGroupId', 'type', 'batchInfo'];
CallListModel.MINUTES_PER_CALL = 5;
exports.CallListModel = CallListModel;
//# sourceMappingURL=call-list.model.js.map